import cardValidator from 'card-validator'
import { BaseServices } from './BaseServices'

export class EvHubPaymentServices extends BaseServices {
  validateCardNumber (cardNumber) {
    return cardValidator.number(cardNumber).isValid
  }
  
  getCardBrand (cardNumber) {
    var cardBrand = cardValidator.number(cardNumber).card.type
    return cardBrand
  }
}
